import _ from "lodash";
import {
  ACCENTS as ACCENTS_ENUM,
  AGENT_NOTIFICATION_OPTIONS as AGENT_NOTIFICATION_OPTIONS_ENUM,
  AUDITION_TYPES as AUDITION_TYPES_ENUM,
  GENRES as GENRES_ENUM,
  ETHNICITIES as ETHNICITIES_ENUM,
  GENDERS as GENDERS_ENUM,
  GENDER_REQUIREMENTS as GENDER_REQUIREMENTS_ENUM,
  PRONOUNS as PRONOUNS_ENUM,
  LANGUAGES as LANGUAGES_ENUM,
  OFFER_STATUSES as OFFER_STATUSES_ENUM,
  POINTS_OF_VIEW as POINTS_OF_VIEW_ENUM,
  RECORDING_LENGTH_DURATION_TYPES as RECORDING_LENGTH_DURATION_TYPES_ENUM,
  RECORDING_LOCATIONS as RECORDING_LOCATIONS_ENUM,
  UNIONS as UNIONS_ENUM,
  VERTICALS as VERTICALS_ENUM,
  USER_TYPES as USER_TYPES_ENUM,
  DEFAULT_MESSAGES as DEFAULT_MESSAGES_ENUM,
} from "./enums";
import {
  VOICE_AGE_RANGE_DATA,
  RECORDING_EXPERIENCE_DATA,
  COUNTRY_DATA,
  STATE_DATA,
} from "./data-population";

// convert enums into objects keyed by enum value name so they can be reused
// in non-typescript projects without looking awful
function objectifyEnum<T extends { [key: string]: string | number }>(
  enumType: T
): { [K in keyof T]: T[K] } {
  const obj = {} as { [K in keyof T]: T[K] };
  for (const key in enumType) {
    obj[key] = enumType[key];
  }
  return obj;
}
function arrangeLocationData(countries, states) {
  const locationData = _.map(
    _.map(countries, (c) => ({ ...c, id: `${c.id}` })),
    (c) => _.pick(c, ["id", "name", "orderIndex", "states"])
  );
  const stateData = _.map(
    _.map(states, (s) => ({ ...s, id: `${s.id}` })),
    (s) => _.pick(s, ["id", "name", "orderIndex", "countryId"])
  );

  _.forEach(locationData, (country) => {
    const statesInCountry = _.filter(
      stateData,
      (s) => parseInt(s.countryId, 10) === parseInt(country.id, 10)
    );
    country.states = statesInCountry;
  });

  return locationData;
}

export const ACCENTS = objectifyEnum(ACCENTS_ENUM);
export const AGENT_NOTIFICATION_OPTIONS = objectifyEnum(
  AGENT_NOTIFICATION_OPTIONS_ENUM
);
export const AUDITION_TYPES = objectifyEnum(AUDITION_TYPES_ENUM);
export const GENRES = objectifyEnum(GENRES_ENUM);
export const ETHNICITIES = objectifyEnum(ETHNICITIES_ENUM);
export const GENDERS = objectifyEnum(GENDERS_ENUM);
export const GENDER_REQUIREMENTS = objectifyEnum(GENDER_REQUIREMENTS_ENUM);
export const PRONOUNS = objectifyEnum(PRONOUNS_ENUM);
export const LANGUAGE = objectifyEnum(LANGUAGES_ENUM);
export const OFFER_STATUSES = objectifyEnum(OFFER_STATUSES_ENUM);
export const POINTS_OF_VIEW = objectifyEnum(POINTS_OF_VIEW_ENUM);
export const RECORDING_LENGTH_DURATION_TYPES = objectifyEnum(
  RECORDING_LENGTH_DURATION_TYPES_ENUM
);
export const RECORDING_LOCATIONS = objectifyEnum(RECORDING_LOCATIONS_ENUM);
export const UNIONS = objectifyEnum(UNIONS_ENUM);
export const VERTICALS = objectifyEnum(VERTICALS_ENUM);
export const USER_TYPES = objectifyEnum(USER_TYPES_ENUM);
export const DEFAULT_MESSAGES = objectifyEnum(DEFAULT_MESSAGES_ENUM);

export const VOICE_RANGES = _.map(
  _.map(VOICE_AGE_RANGE_DATA, (r) => ({ ...r, id: `${r.id}` })),
  (r) => _.pick(r, ["id", "from", "to", "range", "orderIndex"])
);
VOICE_RANGES
export const RECORDING_EXPERIENCES = _.map(
  _.map(RECORDING_EXPERIENCE_DATA, (rexp) => ({ ...rexp, id: `${rexp.id}` })),
  (rexp) => _.pick(rexp, ["id", "from", "to", "range", "orderIndex"])
);
export const LOCATIONS = arrangeLocationData(COUNTRY_DATA, STATE_DATA);
